function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable import/prefer-default-export */

import memoizeOne from 'memoize-one';
import IrisGridUtils from "./IrisGridUtils.js";
/**
 * Checks if 2 grid states are equivalent.
 * Checks values and does not require referential equality of the entire state, just the values we care about.
 * @param gridStateA First grid state
 * @param gridStateB Second grid state
 * @returns True if the states are equivalent
 */
function areGridStatesEqual(gridStateA, gridStateB) {
  var compareKeys = ['isStuckToBottom', 'isStuckToRight', 'movedColumns', 'movedRows'];
  return gridStateA === gridStateB || compareKeys.every(key => gridStateA[key] === gridStateB[key]);
}

/**
 * Checks if 2 iris grid states are equivalent.
 * Checks values and does not require referential equality of the entire state, just the values we care about.
 * @param irisGridStateA First iris grid state
 * @param irisGridStateB Second iris grid state
 * @returns True if the states are equivalent
 */
function areIrisGridStatesEqual(irisGridStateA, irisGridStateB) {
  // Top level keys we want to check for referential equality
  var compareStateKeys = ['advancedFilters', 'aggregationSettings', 'customColumnFormatMap', 'columnAlignmentMap', 'isFilterBarShown', 'quickFilters', 'customColumns', 'reverse', 'rollupConfig', 'showSearchBar', 'searchValue', 'selectDistinctColumns', 'selectedSearchColumns', 'sorts', 'invertSearchColumns', 'pendingDataMap', 'frozenColumns', 'conditionalFormats', 'columnHeaderGroups', 'partitionConfig'];
  return irisGridStateA === irisGridStateB || irisGridStateA.metrics != null && irisGridStateB.metrics != null && irisGridStateA.metricCalculator === irisGridStateB.metricCalculator && irisGridStateA.metrics.userColumnWidths === irisGridStateB.metrics.userColumnWidths && irisGridStateA.metrics.userRowHeights === irisGridStateB.metrics.userRowHeights && compareStateKeys.every(key => irisGridStateA[key] === irisGridStateB[key]);
}

/**
 * Creates a dehydrator function for grid state that is memoized on the last call.
 * Only tracks 1 state at a time. If the model and input states are equal, returns the same dehydrated state object reference.
 * @returns A dehydrator function memoized on the last call
 */
function makeMemoizedGridStateDehydrator() {
  return memoizeOne((model, gridState) => IrisGridUtils.dehydrateGridState(model, gridState), (_ref, _ref2) => {
    var _ref3 = _slicedToArray(_ref, 2),
      modelA = _ref3[0],
      gridStateA = _ref3[1];
    var _ref4 = _slicedToArray(_ref2, 2),
      modelB = _ref4[0],
      gridStateB = _ref4[1];
    return modelA === modelB && areGridStatesEqual(gridStateA, gridStateB);
  });
}

/**
 * Creates a dehydrator function for iris grid state that is memoized on the last call.
 * Only tracks 1 state at a time. If the model and input states are equal, returns the same dehydrated state object reference.
 * @returns A dehydrator function memoized on the last call
 */
function makeMemoizedIrisGridStateDehydrator() {
  return memoizeOne((model, irisGridState) => {
    var irisGridUtils = new IrisGridUtils(model.dh);
    return irisGridUtils.dehydrateIrisGridState(model, irisGridState);
  }, (_ref5, _ref6) => {
    var _ref7 = _slicedToArray(_ref5, 2),
      modelA = _ref7[0],
      irisGridStateA = _ref7[1];
    var _ref8 = _slicedToArray(_ref6, 2),
      modelB = _ref8[0],
      irisGridStateB = _ref8[1];
    return modelA === modelB && areIrisGridStatesEqual(irisGridStateA, irisGridStateB);
  });
}

/**
 * Creates a dehydrator function for grid and iris grid state that is memoized on the last call.
 * Only tracks 1 state at a time. If the model and input states are equal, returns the same dehydrated state object reference.
 * Combines the dehydrated grid and iris grid states into a single object.
 * @returns A dehydrator function memoized on the last call
 */
function makeMemoizedCombinedGridStateDehydrator() {
  return memoizeOne((model, irisGridState, gridState) => {
    var irisGridUtils = new IrisGridUtils(model.dh);
    return _objectSpread(_objectSpread({}, irisGridUtils.dehydrateIrisGridState(model, irisGridState)), IrisGridUtils.dehydrateGridState(model, gridState));
  }, (_ref9, _ref0) => {
    var _ref1 = _slicedToArray(_ref9, 3),
      modelA = _ref1[0],
      irisGridStateA = _ref1[1],
      gridStateA = _ref1[2];
    var _ref10 = _slicedToArray(_ref0, 3),
      modelB = _ref10[0],
      irisGridStateB = _ref10[1],
      gridStateB = _ref10[2];
    return modelA === modelB && areIrisGridStatesEqual(irisGridStateA, irisGridStateB) && areGridStatesEqual(gridStateA, gridStateB);
  });
}
export var IrisGridCacheUtils = {
  makeMemoizedGridStateDehydrator,
  makeMemoizedIrisGridStateDehydrator,
  makeMemoizedCombinedGridStateDehydrator
};
//# sourceMappingURL=IrisGridCacheUtils.js.map